"use strict";var $export=require("./_export"),$task=require("./_task");$export($export.G+$export.B,{setImmediate:$task.set,clearImmediate:$task.clear});